import { withSearch } from '@elastic/react-search-ui';
import { useDocumentMeta } from '../hooks/useDocumentMeta';

const DocumentMetaUpdater = ({ resultSearchTerm, current, searchName }) => {
  useDocumentMeta({ resultSearchTerm, current, searchName });

  return null;
};

export default withSearch(({ resultSearchTerm, current }) => ({
  resultSearchTerm,
  current,
}))(DocumentMetaUpdater);
